
import { defineComponent } from 'vue'
import { useCompany } from '@/swr/swr.company'
import { useUser } from '@/swr/swr.user'

export default defineComponent({
  data() {
    return {
      recipient: 'support@attensi.com',
      ...useCompany(),
      ...useUser(),
    }
  },
  computed: {
    mailto(): string {
      const subject = 'Access Denied Attensi Insights'
      const body = `User: ${this.user?.username} %0D%0ACompany: ${this.company?.name}`
      return `mailto:${this.recipient}?subject=${subject}&body=${body}`
    },
  },
})
